import type { CarrierOption } from '@/features/purchase-orders/hooks'

/** "Thu, Nov 6": a delivery date staff compare at a glance. */
export function arrivalLabel(date: string) {
  const [y, m, d] = date.split('-').map(Number)
  return new Date(y ?? 0, (m ?? 1) - 1, d ?? 1).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })
}

/** "UPS UPS Ground" → "UPS Ground"; WWEX repeats the carrier in parcel service names. */
export function carrierTitle(option: Pick<CarrierOption, 'carrier_name'>) {
  const words = option.carrier_name.trim().split(/\s+/)
  return words.length > 1 && words[0]?.toLowerCase() === words[1]?.toLowerCase()
    ? words.slice(1).join(' ')
    : option.carrier_name
}

/** The service under the carrier, when it adds something: "Guaranteed", not a repeat of the name. */
export function serviceLabel(option: Pick<CarrierOption, 'carrier_name' | 'service_level'>) {
  const service = option.service_level.trim()
  if (!service || option.carrier_name.toLowerCase().includes(service.toLowerCase())) return null
  return service === service.toUpperCase() ? service.charAt(0) + service.slice(1).toLowerCase() : service
}
